module.exports = __webpack_public_path__ + "img/fapiaoshenqing.02b156a7.png";